<template>
	<div class="display-flex justify-content-space-between align-items-center">
		<div class="body-sm text-color-content-tertiary display-flex align-items-center mb-50">
			<BaseLink :link="{ router: 'help-center-landing' }" class="text-color-content-tertiary">
				Help Center
			</BaseLink>
			<BaseSvgIcon v-if="category || searchResults" name="chevron" dir="right" class="ml-50 mr-50" />
			<section v-if="category">
				<BaseLink
					:link="{ router: 'help-center-category', params: { categoryId: category.id } }"
					class="text-color-current-color ellipsis"
					data-test="category-link"
				>
					{{ category.name }}
				</BaseLink>
				<BaseSvgIcon v-if="section" name="chevron" dir="right" class="ml-50 mr-50" />
				<BaseLink
					v-if="section"
					:link="{ router: 'help-center-section', params: { sectionId: section.id } }"
					class="text-color-current-color ellipsis"
					data-test="section-link"
				>
					{{ section.name }}
				</BaseLink>
			</section>
			<span
				v-else-if="searchResults"
				class="text-color-current-color font-weight-bold"
				data-test="search-results"
			>
				Search results
			</span>
		</div>
		<div>
			<HelpCenterSearchBar class="display-none-smo" :placeholder="'Search...'" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { HelpCenterCategory, HelpCenterSection } from 'types/help-center';
import HelpCenterSearchBar from '@components/help-center/help-center-search-bar.vue';

interface Props {
	category?: HelpCenterCategory | null;
	section?: HelpCenterSection | null;
	searchResults?: boolean;
}

withDefaults(defineProps<Props>(), {
	category: null,
	section: null,
	searchResults: false
});
</script>
